import { map } from 'ramda';
import parse from 'html-react-parser';
import { InfoMessage } from '@fasstech/middle-design-system';
import { simpleMarkdownToHtml } from '@@viewHelpers/format.jsx';

const SimulationPricingsSelfWorkerExtraRecommendationMessages = ({ recommendationMessages }) =>
  map(
    recommendationMessage => (
      <InfoMessage
        key={recommendationMessage}
        iconName="lightbulb"
        className="w-full mb-4"
      >
        {parse(simpleMarkdownToHtml(recommendationMessage))}
      </InfoMessage>
    ),
    recommendationMessages
  );

export default SimulationPricingsSelfWorkerExtraRecommendationMessages;
